import autoComplete from "@tarekraafat/autocomplete.js";

export default function staff() {
	let analysts      = document.querySelectorAll('.analyst-loop .wp-block-post');
	let search_clear  = document.querySelector('.topic-search__button');
	let active_term   = document.querySelector('.topic-search__searching-by-term');
	let search_active = false;
	let active_class  = 'search-topics-active';
	
	if ( document.getElementById('analystAutoComplete') ) {
		const analystAutoCompletejs = new autoComplete({
			selector: "#analystAutoComplete",
			placeHolder: analystData.search_placeholder,
			data: {
				src: analystData.terms,
				keys: ['name'],
			},
			resultItem: {
				highlight: true,
			},
			events: {
				input: {
					selection: (event) => {
						search_active = true;
						document.body.classList.add(active_class);
	
						const selection = htmlDecode(event.detail.selection.value.name);
						analystAutoCompletejs.input.value = selection;
	
						active_term.innerHTML = selection;
	
						analysts.forEach((analyst) => {
							if ( ! analyst.classList.contains( 'area-of-expertise-' + event.detail.selection.value.slug ) ) {
								analyst.classList.add('hide');
							} else {
								analyst.classList.remove('hide');
							}
						});
					}
				}
			}
		});

		const htmlDecode = (input) => {
			var doc = new DOMParser().parseFromString(input, "text/html");
			return doc.documentElement.textContent;
		};
	
		search_clear.addEventListener('click', (e) => {
			search_active = false;
			document.body.classList.remove(active_class);
			analysts.forEach((analyst) => {
				analyst.classList.remove('hide');
			});
	
			analystAutoCompletejs.input.value = '';
		});
	}
}